export default function Plaintext({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  return (
    <p className={className}>
      {(text || "").replace("\r\n\r\n", "<br/><br/>")}
    </p>
  );
}
